export const extend = (extending, newTheme) => ({ ...extending, ...newTheme });
